// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The requests an editor made of the dataflow's owner, above a catalog
   drawer's cards: each is an install's review card under the name of who
   asked. */
.VfR5ey3Pa3k0eg3a7m5R {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 14px;
}

.C1PlMqeg7O3pGw1UHItn {
  font-size: var(--curio-font-size-sm);
  font-weight: 600;
  color: var(--curio-text-secondary);
}

.hlU8aI5e87vBdNb9f7Wc {
  font-size: var(--curio-font-size-xs);
  color: var(--curio-text-meta);
  margin-bottom: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/catalog/EditorRequestsSection.module.css"],"names":[],"mappings":"AAAA;;WAEW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;AACpB","sourcesContent":["/* The requests an editor made of the dataflow's owner, above a catalog\n   drawer's cards: each is an install's review card under the name of who\n   asked. */\n.requests {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.requestsTitle {\n  font-size: var(--curio-font-size-sm);\n  font-weight: 600;\n  color: var(--curio-text-secondary);\n}\n\n.requestBy {\n  font-size: var(--curio-font-size-xs);\n  color: var(--curio-text-meta);\n  margin-bottom: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"requests": `VfR5ey3Pa3k0eg3a7m5R`,
	"requestsTitle": `C1PlMqeg7O3pGw1UHItn`,
	"requestBy": `hlU8aI5e87vBdNb9f7Wc`
};
export default ___CSS_LOADER_EXPORT___;
